import React from "react";
import filter from "../../../assets/images/filter.svg";
import blueFilter from "../../../assets/images/BlueFilterIcon.svg";

const ProjectNameHeader = (options, frozenCoulmns, sortData, projectNameOnClick, selectedFields) => {
  let splittedCol = options?.split("_").join(" ");
  const isFilterActivated =
    (selectedFields && Object.keys(selectedFields)?.length && selectedFields[options]?.length>0);
    const isFrozen = frozenCoulmns?.includes(options);
  return (
    <div  className={`flex-display ${
      isFrozen ? "font-bold frozen-width" : ""
    }`}>
      <>
        <img
          src={isFilterActivated ? blueFilter : filter}
          alt="Column Filter"
          className="columnFilterIcon"
          onClick={(e) => projectNameOnClick(e, options)}
        />
        <span className="columnFilterIcon">
          {splittedCol === "Estimated AW Printer" && "Estimated AW@Printer date (AWM)"}
          {splittedCol === "AWPrinterDate" && "AW Date (DSBP)"}
          {splittedCol === "POAReleaseDate" && "ETA (AWM)"}
          {splittedCol === "Artwork Category" && "Category"}
          {splittedCol === "Project region" && "Region"}
          {splittedCol === "Artwork Brand" && "Brand"}
          {splittedCol === "Project Scale" && "Scale"}
          {splittedCol === "Company" && "FA Supplier"}
          {splittedCol === "Buffer To Work" && "B:W"}
          {splittedCol === "Artwork SMO" && "SMO"}
          {splittedCol === "ProjectStatusComment" && "Project Status Comment"}
          
          {splittedCol !== "Estimated AW Printer" &&
            splittedCol !== "AWPrinterDate" &&
            splittedCol !== "POAReleaseDate" &&
            splittedCol !== "Artwork Category" &&
            splittedCol !== "Buffer To Work" &&
            splittedCol !== "Project region" &&
            splittedCol !== "Artwork Brand" &&
            splittedCol !== "Project Scale" &&
            splittedCol !== "Artwork SMO" &&
            splittedCol !== "Company" &&
            splittedCol !== "ProjectStatusComment" &&
            splittedCol}
        </span>
      </>
    </div>
  );
};

export default ProjectNameHeader;